import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { AppConfig } from "./app-config.service";

@Injectable({
    providedIn: 'root'
})
export class BaseService {
    private apiUrl: string = AppConfig.settings.apiUrl;;

    constructor(private http: HttpClient) {
    }

    public get<T>(url: string, options?: object) {
        return this.http.get<T>(this.apiUrl + url, options);
    }

    public getById<T>(url: string, id: any, options?: object) {
        return this.http.get<T>(`${this.apiUrl}${url}/${id}`, options);
    }

    public post<T>(url: string, data: T, options?: object) {
        return this.http.post<T>(this.apiUrl + url, data, options);
    }

    public delete<T>(url: string, options?: object) {
        return this.http.delete<T>(this.apiUrl + url, options);
      }
}